/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux';
import { getHigherUnitName, getPriceUnit, skuTypesListWithId, useProductData } from '@/Helpers';
import VariantTable from './VariantTable';
import { Loader2 } from 'lucide-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import GlobalSearch from '@/Components/globalSearch/search';
import { SelectPicker } from 'rsuite';
import { notificationServices } from '@/Services';
import allProductServices from '@/Services/Form Services/allproduct.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import moment from 'moment';

let columns = [
    {
        title: 'ID',
        key: 'id',
    },
    {
        title: 'Product Name',
        key: 'name',
    },
    {
        title: 'SKU Type',
        key: 'skuType',
    },
    {
        title: 'Category',
        key: 'category',
    },
    {
        title: 'Sub Category',
        key: 'subCategory',
    },
    {
        title: 'Unit',
        key: 'unit',
    },
    {
        title: 'Size 1',
        key: 'size1',
    },
    {
        title: 'Size 2',
        key: 'size2',
    },
    {
        title: 'Size 3',
        key: 'size3',
    },
    {
        title: 'Size 4',
        key: 'size4',
    },
    {
        title: 'Size 5',
        key: 'size5',
    },
    {
        title: 'Size 6',
        key: 'size6',
    },
    {
        title: 'Size 7',
        key: 'size7',
    },
    {
        title: 'Size 8',
        key: 'size8',
    },
    {
        title: 'Size 9',
        key: 'size9',
    },
    {
        title: 'Size 10',
        key: 'size10',
    },
    {
        title: 'Size 11',
        key: 'size11',
    },
    {
        title: 'Size 12',
        key: 'size12',
    }
];

const colMapping = {
    id: 'id',
    name: 'productName',
    skuType: 'skuType',
    category: 'categoryName',
    subCategory: 'subCategoryName',
    unit: 'unit',
};

function VariantPriceUpdate() {
    const productList = useSelector((state) => state?.form?.ALL_PRODUCTS?.data?.LIST);
    const isLoading = useSelector((state) => state?.form?.ALL_PRODUCTS?.loading); // Add loading state from redux
    const emptyVariant = productList?.every((product) => product?.variants?.length === 0);
    const dispatch = useDispatch();
    const [search, setSearch] = useState(null);
    const [selectSkuType, setSelectSkuType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true); // Track initial load

    // Use refs for better performance
    const updatePriceRef = useRef({});
    const originalPricesRef = useRef({});
    const changePriceRef = useRef(false);
    const [, forceUpdate] = useState({});
    const { userConfig = {} } = useAuth()
    const { level } = userConfig?.userDetails || {};

    useEffect(() => {
        console.log('Component mounted, fetching product data...');
        useProductData(dispatch);
        setInitialLoad(true);
    }, []);

    useEffect(() => {
        if (productList && productList.length > 0) {
            console.log('Product list loaded:', productList.length, 'products');
            const newUpdatePrice = {};
            const newOriginalPrices = {};

            productList.forEach((product) => {
                if (product?.variants) {
                    newUpdatePrice[product.id] = {};
                    newOriginalPrices[product.id] = {};

                    product.variants.forEach((variant) => {
                        const convertedPrice = getPriceUnit(variant, undefined, product?.unit, 'costPrice');
                        newUpdatePrice[product.id][variant.id] = convertedPrice?.[0].toFixed(3);
                        newOriginalPrices[product.id][variant.id] = convertedPrice?.[0].toFixed(3);
                    });
                }
            });

            updatePriceRef.current = newUpdatePrice;
            originalPricesRef.current = newOriginalPrices;
            changePriceRef.current = false;
            setInitialLoad(false);
            forceUpdate({});
        }
    }, [productList]);

    useEffect(() => {
        if (!initialLoad && ((Array.isArray(productList) && productList.length === 0) || emptyVariant)) {
            console.log('Data missing, refetching...');
            useProductData(dispatch);
        }
    }, [productList, emptyVariant, initialLoad, dispatch]);

    const handlePrice = (product, value, variantId) => {
        const numericValue = parseFloat(value) || 0;

        if (numericValue < 0) {
            return;
        }

        const originalPrice = originalPricesRef.current[product?.id]?.[variantId] || 0;
        const hasChanged = numericValue !== parseFloat(originalPrice);

        if (hasChanged) {
            changePriceRef.current = true;
        }

        if (!updatePriceRef.current[product?.id]) {
            updatePriceRef.current[product?.id] = {};
        }
        updatePriceRef.current[product?.id][variantId] = numericValue;
        forceUpdate({});
    };

    const saveAllPrices = async () => {
        setLoading(true);
        const editValues = {};
        let hasChanges = false;

        Object.keys(updatePriceRef.current).forEach((productId) => {
            const productPrices = updatePriceRef.current[productId];
            const originalProductPrices = originalPricesRef.current[productId];
            const changedPrices = {};

            Object.keys(productPrices).forEach((variantId) => {
                const currentPrice = parseFloat(productPrices[variantId]);
                const originalPrice = parseFloat(originalProductPrices[variantId]);

                if (currentPrice !== originalPrice) {
                    changedPrices[variantId] = currentPrice;
                    hasChanges = true;
                }
            });

            if (Object.keys(changedPrices).length > 0) {
                editValues[productId] = changedPrices;
            }
        });

        const req = {
            data: {
                editValues,
            },
        };

        if (hasChanges) {
            const notificationId = notificationServices.generateNotification({
                type: 'loading',
                message: 'Updating prices...',
            });
            try {
                const response = await allProductServices.updateVariantPrice(req);
                if (response.statusCode === 200) {
                    notificationServices.generateNotification({
                        type: 'success',
                        message: response?.message ?? 'Prices updated successfully',
                        config: {
                            id: notificationId,
                        },
                    });

                    // FIX 4: Refresh data after successful update
                    setTimeout(() => {
                        useProductData(dispatch);
                    }, 1000);
                    changePriceRef.current = false;
                }
            } catch (error) {
                notificationServices.generateNotification({
                    type: 'error',
                    message: error.message ?? error ?? 'Price update failed',
                    config: {
                        id: notificationId,
                    },
                });
            }
        } else {
            notificationServices.generateNotification({
                type: 'info',
                message: 'No changes to save',
            });
        }
        setLoading(false);
    };

    const createSizeColumn = (sizeKey) => {
        return (product, index) => {
            const variant = product?.variants?.find((variant) => variant?.size === sizeKey);
            if (!variant) return <div className='text-center text-gray-500'>-</div>;

            const currentPrice = updatePriceRef.current[product?.id]?.[variant?.id] || '';
            const originalPrice = originalPricesRef.current[product?.id]?.[variant?.id] || 0;
            const hasChanged = parseFloat(currentPrice) !== parseFloat(originalPrice);
            const unit = getPriceUnit(variant, undefined, product?.unit, 'costPrice')?.[1];
            const date = variant?.costPriceUpdatedAt
                ? moment(variant.costPriceUpdatedAt, "YYYY-MM-DD HH:mm:ss").format('D MMMM YYYY HH:mm:ss')
                : '';
            return (
                <div className='flex flex-col gap-2 items-center'>
                    <span className='text-gray-700'>{variant?.displayName}({variant?.clientVariantId})</span>
                    <div className='flex items-center space-x-3'>
                        <div className='flex items-center'>
                            <span className='text-sm text-gray-500 mr-2'>₹/{unit}</span>
                            <input
                                type='number'
                                value={currentPrice}
                                onChange={(e) => handlePrice(product, e.target.value, variant?.id)}
                                placeholder='0.00'
                                step='0.001'
                                className={`w-24 px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${hasChanged ? 'border-blue-500 bg-blue-50' : 'border-gray-300'}`}
                            />
                        </div>
                    </div>
                    {variant?.costPriceUpdatedAt && (
                        <div className='text-green-500 text-[12px] text-nowrap'>{date}</div>
                    )}
                </div>
            );
        };
    };

    const customRowData = {
        name: (product, index) => {
            return <div className='font-medium text-gray-900'>{product?.productName}</div>
        },
        skuType: (product, index) => {
            return (
                <span className='inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800'>
                    {product?.skuType}
                </span>
            );
        },
        unit: (product, index) => {
            return <div className='text-gray-500'>{getHigherUnitName(product?.unit)}</div>;
        },
        size1: createSizeColumn('size1'),
        size2: createSizeColumn('size2'),
        size3: createSizeColumn('size3'),
        size4: createSizeColumn('size4'),
        size5: createSizeColumn('size5'),
        size6: createSizeColumn('size6'),
        size7: createSizeColumn('size7'),
        size8: createSizeColumn('size8'),
        size9: createSizeColumn('size9'),
        size10: createSizeColumn('size10'),
        size11: createSizeColumn('size11'),
        size12: createSizeColumn('size12'),
    };

    const dropDownItems = [
        {
            label: 'Product Name',
            value: 'productName',
            placeholder: 'Search by Product Name',
        },
        {
            label: 'Variant Name',
            value: 'variantName',
            placeholder: 'Search by Variant Name',
        },
        {
            label: 'SKU Type',
            value: 'skuType',
            placeholder: 'Search by SKU Type',
        },
        {
            label: 'Category',
            value: 'category',
            placeholder: 'Search by Category',
        },
    ];

    const getFilteredData = useCallback(() => {
        if (!productList) return [];

        let filteredData = productList;
        const selectedSkuType = skuTypesListWithId.find((item) => item.id === selectSkuType)?.title;

        if (selectSkuType) {
            filteredData = filteredData.filter((product) =>
                product?.skuType?.toLowerCase().includes(selectedSkuType.toLowerCase())
            );
        }

        if (search?.searchValue) {
            switch (search?.value) {
                case 'productName':
                    filteredData = filteredData.filter((product) =>
                        product?.productName?.toLowerCase().includes(search?.searchValue.toLowerCase())
                    );
                    break;
                case 'variantName':
                    filteredData = filteredData.filter((product) =>
                        product?.variants?.some((variant) =>
                            variant?.displayName?.toLowerCase().includes(search?.searchValue.toLowerCase())
                        )
                    );
                    break;
                case 'skuType':
                    filteredData = filteredData.filter((product) =>
                        product?.skuType?.toLowerCase().includes(search?.searchValue.toLowerCase())
                    );
                    break;
                case 'category':
                    filteredData = filteredData.filter((product) =>
                        product?.categoryName?.toLowerCase().includes(search?.searchValue.toLowerCase())
                    );
                    break;
                default:
                    break;
            }
        }
        return filteredData;
    }, [productList, search?.searchValue, search?.value, selectSkuType]);

    if (initialLoad || isLoading) {
        return (
            <div className='flex items-center justify-center h-64'>
                <Loader2 className='w-8 h-8 animate-spin text-blue-600' />
                <span className='ml-2 text-gray-600'>Loading products...</span>
            </div>
        );
    }

    if (!productList || productList.length === 0) {
        return (
            <div className='flex flex-col items-center justify-center h-64'>
                <p className='text-gray-500 text-lg'>No products found</p>
                <button
                    onClick={() => useProductData(dispatch)}
                    className='mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700'
                >
                    Retry Loading
                </button>
            </div>
        );
    }

    return (
        <div className='flex flex-col p-2'>
            <div className='flex items-center justify-between mb-4 w-full'>
                <h1 className='text-xl font-bold'>Variant Price Update</h1>
                <div className='flex items-center gap-2 text-sm'>
                    <div className='flex items-center gap-2'>
                        <span className='text-gray-500'>Total Products:</span>
                        <span className='text-gray-500'>{getFilteredData()?.length ?? 0}</span>
                    </div>
                    <div className='flex items-center gap-2'>
                        <span className='text-gray-500'>Total Variants:</span>
                        <span className='text-gray-500'>
                            {getFilteredData()?.reduce((acc, product) => acc + (product?.variants?.length || 0), 0)}
                        </span>
                    </div>
                    {level !== 1 && (
                        <button
                            disabled={loading || !changePriceRef.current}
                            onClick={saveAllPrices}
                            className={`px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${loading || !changePriceRef.current
                                    ? 'bg-gray-400 cursor-not-allowed'
                                    : 'bg-blue-600 hover:bg-blue-700'
                                }`}
                        >
                            {loading ? (
                                <>
                                    <Loader2 className='w-4 h-4 mr-2 animate-spin' />
                                    Updating...
                                </>
                            ) : (
                                'Update Prices'
                            )}
                        </button>
                    )}
                </div>
            </div>

            <div className='flex items-center justify-start gap-3 mb-4 w-full'>
                <div className='w-[50%]'>
                    <GlobalSearch
                        dropDownOptions={dropDownItems}
                        searchDropDown={true}
                        setSelectedValue={setSearch}
                    />
                </div>
                <SelectPicker
                    data={skuTypesListWithId.map((item) => ({
                        label: item.title,
                        value: item.id,
                    }))}
                    onChange={(value) => setSelectSkuType(value)}
                    placeholder='Select SKU Type'
                    value={selectSkuType}
                    className='w-[40%]'
                />
            </div>
            <div className='justify-end flex items-center gap-2 mb-2'>
                <span
                    className='inline-block w-3 h-3 rounded-full bg-green-500 border border-green-600'
                    style={{ minWidth: '12px', minHeight: '12px' }}
                ></span>
                <span className='text-sm text-gray-700'><span className='font-medium'>Updated At</span></span>
            </div>
            <div className='h-[calc(100vh-220px)]'>
                <VariantTable
                    data={getFilteredData()}
                    columns={columns}
                    colMapping={colMapping}
                    customRowData={customRowData}
                />
            </div>
        </div>
    );
}

export default VariantPriceUpdate;